import axiosClient from './axiosClient';
import { IProfile, IStudent } from '~/utils/interface/profile';
import { IBaseResponse } from '~/utils/interface/base';
import { urlApiUser } from '~/utils/constants/apis';
import { ContentTypeEnum } from '~/utils/enum/common';
import { INotifications } from '~/utils/interface/notifications';

export const userApi = {
  getProfile() {
    const url = `${urlApiUser.getList}`;
    return axiosClient.get<IBaseResponse<IProfile>>(url);
  },

  updateProfile(body: FormData) {
    const url = `${urlApiUser.updateProfile}`;

    return axiosClient.put<IBaseResponse<{ avatarUrl: string }>>(url, body, {
      headers: { 'Content-Type': ContentTypeEnum.FORM_DATA },
    });
  },

  getStudents() {
    const url = `${urlApiUser.getStudents}`;
    return axiosClient.get<IBaseResponse<IStudent[]>>(url);
  },
};
